/**
 * @generated SignedSource<<d4c12d1f4ef294ef8feb2411578ca031>>
 * @relayHash f837607613541f2d59174c00f8a94698
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4f46006fe4d7f77f58b8b5ba08a0658fb8fc6edb90c0e7720add84d34b77f4b3

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessTimelineEmbedAppMemoQuery } from './JiraBusinessTimelineEmbedAppMemoQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessTimelineEmbedAppMemoQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4f46006fe4d7f77f58b8b5ba08a0658fb8fc6edb90c0e7720add84d34b77f4b3",
    "metadata": {},
    "name": "JiraBusinessTimelineEmbedAppMemoQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
